import { combineReducers } from '@reduxjs/toolkit';

// Feature scoped APIs
import { appointmentsApi } from '../actions/appointments';
import { conflictsApi } from '../actions/appointments/conflicts';
import { missingQualificationsApi } from '../actions/appointments/missingQualifications';
import { rejectedApi } from '../actions/appointments/rejected';
import { unallocatedApi } from '../actions/appointments/unallocated';
import { awardAlertsApi } from '../actions/awardAlerts';
import { clientsApi } from '../actions/clients';
import { publishApi } from '../actions/index';
import { usersApi } from '../actions/users';
import { usersRunningLateApi } from '../actions/users/runningLate';
// Reducers
import * as appointmentsReducers from './appointments';
import awardAlerts from './awardAlerts';
import bulkAssignees from './bulkAssignees';
import * as clientsReducers from './clients';
import unsaved from './unsaved';
import * as usersReducers from './users';
import runningLate from './users/runningLate';
import visualise from './visualise';
import weeklyPlannerReducer from './weeklyPlanner';

export const weeklyPlanner = {
  ...appointmentsReducers,
  ...clientsReducers,
  ...usersReducers,
  weeklyPlanner: weeklyPlannerReducer,
  awardAlerts,
  runningLate,
  unsaved,
  bulkAssignees,
  visualise,
};

export default combineReducers(weeklyPlanner);

// Export feature-scoped APIs array
export const weeklyPlannerApis = [
  appointmentsApi,
  awardAlertsApi,
  clientsApi,
  conflictsApi,
  missingQualificationsApi,
  publishApi,
  rejectedApi,
  usersApi,
  usersRunningLateApi,
  unallocatedApi,
] as const;
